import * as React from "react";
import { graphql } from "gatsby";
import HygieneTemplate from "../templates/hygienePage";

const HygieneWithData = ({ data }) => {
  return (
    <HygieneTemplate data={data.prismicHygienePage}>
      <div
        className="iubenda-policy-content"
        dangerouslySetInnerHTML={{ __html: data.iubendaPolicy?.content || "" }}
      />
    </HygieneTemplate>
  );
};

export const hygienePageQuery = graphql`
  query ($uid: String) {
    prismicHygienePage(uid: { eq: $uid }) {
      data {
        meta_title
        meta_description
      }
    }
    iubendaPolicy(uid: { eq: $uid }) {
      content
    }
  }
`;

export default HygieneWithData;
